<template>
    <v-container fluid grid-list-lg>
        <div v-if="!hasFeeds">
            <p>
                Your latest news will appear here. Add RSS feeds to further customise where you'll get the latest updates from.
            </p>
            <p>
                <v-btn color="primary" large @click="openAddFeedDialog">
                <v-icon>mdi-plus</v-icon>
                Add New Feed
                </v-btn>
            </p>
        </div>
        <!-- <v-layout row wrap>
            <v-layout xs12 v-for="feed in getCurrentFeeds" v-key="">
                <v-card :color="feed.color">
                    <v-card-title primary-title>
                    <div class="headline">{{feed.title}}</div>
                    </v-card-title>
                    <v-card-text>
                    {{feed.content | maxText }}
                    </v-card-text>
                    <v-card-actions>
                    <v-btn flat target="_new" :href="feed.url">Read on {{feed.feedTitle}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-layout>
        </v-layout> -->

        <v-dialog v-model="addFeedDialog" max-width="500px">
            <v-card>
                <v-card-title>Add Feed</v-card-title>
                <v-card-text>
                Add the RSS URL for a feed below, or the URL for the site (to auto-discover the Feed).
                <v-text-field v-model="addURL" label="URL" :error="urlError"
                :rules="urlRules"></v-text-field>
                </v-card-text>
                <v-card-actions>
                <v-btn color="primary" @click.stop="addFeed">Add</v-btn>
                <v-btn color="primary" flat @click.stop="addFeedDialog=false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import RSSDataService from './../../../services/rssDataService.js';

export default {
    data () {
      return {
        localFeeds: {},
        addURL: "",
        addFeedDialog: false,
        rssDataService: new RSSDataService(),
      }
    },
    components: {
      
    },
    props: 
    {
    },
    methods: {
        openAddFeedDialog(){
            this.addFeedDialog = true;
            this.addURL = "";
        },
        closeAddFeedDialog(){
            this.addFeedDialog = false;
        },
        addFeed(){
            //this.rssDataService.addFeed(this.addURL);
        },
        random_rgba() {
            var o = Math.round, r = Math.random, s = 255;
            return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
        }
    },
    computed: {
        hasFeeds(){
            if (this.localfeeds && this.localfeeds.length > 0){
                return true;
            }
            return false;
        },
        // getCurrentFeeds(){
        //     if (this.hasFeeds){
        //         //Return our collection of feeds in the correct format
        //     } else {
        //         //Otherwise, go get some feeds?
        //     }
        // }
    },
    watch: {
    }
  }
</script>